<template>
  <div>
    <b-button size="sm" variant="success" @click="ver = true">+ contenido</b-button>

    <b-modal @show="Limpiar" id="modal-1" v-model="ver" title="Agregar Contenido" no-close-on-backdrop>
      <b-form-input type="number" class="my-1" v-model="Prod.Cantidad" placeholder="Cantidad" autofocus></b-form-input>

      <div class="lleno">
        <v-select v-model="Prod.Producto" placeholder="buscar producto" :options="productos" />
      </div>

      <template #modal-footer>
        <b-button size="sm" @click="onAgregar" variant="success">Agregar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/firestore";

if (!firebase.apps.length) firebase.initializeApp({ projectId: "diazvelizexpress" });
else firebase.app();

const db = firebase.firestore();

export default {
  computed: {
    productos() {
      let rs = this.Productos.map((p) => {
        return {
          label: p.Nombre,
          value: p,
        };
      });

      return rs;
    },
  },
  data() {
    return {
      ver: false,
      Prod: { Cantidad: null },
      Productos: null,
    };
  },
  methods: {
    Limpiar() {
      this.Prod = { Cantidad: null, Producto: null };
    },
    onAgregar() {
      if (this.Prod.Producto != null && this.Prod.Cantidad != null) {
        this.$emit("onAddContenido", { Cantidad: this.Prod.Cantidad, Producto: this.Prod.Producto.value });
      }
      this.ver = false;
    },
  },
  firestore: {
    Productos: db.collection("Producto"),
  },
};
</script>
<style scoped>
.lleno {
  width: 100%;
}
</style>
